import { c as _c } from "react/compiler-runtime";
import { NavArrowLeft, NavArrowRight } from '@byway/icons';
import { useMemo } from 'react';
import { Image } from 'react-datocms';
import { Carousel } from '~/components/ReactAriaCarousel/Carousel';
import { CarouselButton } from '~/components/ReactAriaCarousel/CarouselButton';
import { CarouselItem } from '~/components/ReactAriaCarousel/CarouselItem';
import { CarouselScroller } from '~/components/ReactAriaCarousel/CarouselScroller';
import { usePlaygroundAllCmsPlaces } from '~/stores/playgroundStore';
import type { StayTransformed } from '~/types/JourneyItem.types';
import { getStayPlaceImages } from './getStayPlaceImages';
import styles from './TripImageCarousel.module.css';
type TripImageCarouselProps = {
  stays: StayTransformed[];
};
export function TripImageCarousel(t0) {
  const $ = _c(9);
  const {
    stays
  } = t0;
  const cmsPlaces = usePlaygroundAllCmsPlaces();
  let t1;
  if ($[0] !== cmsPlaces || $[1] !== stays) {
    t1 = getStayPlaceImages(stays, cmsPlaces);
    $[0] = cmsPlaces;
    $[1] = stays;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const images = t1;
  if (!images || images.length === 0) {
    return null;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CarouselButton dir="prev" className={styles.button}><NavArrowLeft size="small" decorative={true} /><span className="sr-only">Previous image</span></CarouselButton>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles.buttons}>{t2}<CarouselButton dir="next" className={styles.button}><NavArrowRight size="small" decorative={true} /><span className="sr-only">Next image</span></CarouselButton></div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== images) {
    t4 = images.map(_temp);
    $[5] = images;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className={styles.container}><Carousel className={styles.carousel} spaceBetweenItems="0px" itemsPerPage={1} mouseDragging={true} scrollBy="item" aria-label="Trip place images">{t3}<CarouselScroller className={styles.scroller}>{t4}</CarouselScroller></Carousel></div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
function _temp(image, index) {
  return <CarouselItem key={`${index}-${image.placeName}`} className={styles.item}><div className={styles.imageWrapper}>{image.responsiveImage && <><Image data={image.responsiveImage} className={styles.image} objectFit="cover" layout="fill" /><div className={styles.caption}>{image.placeName}</div></>}</div></CarouselItem>;
}